import {QualificationTier} from '@nxcr-org/web-api-interface/lib/domain_pb'
import {ProcessOptions} from '../../useReservation'

export const getStartingDecision = (
  currentTier: QualificationTier
) => {
  switch (currentTier) {
  case QualificationTier.TIER_1:
  case QualificationTier.TIER_2:
  case QualificationTier.TIER_3:
  case QualificationTier.TIER_1_MANUAL:
  case QualificationTier.TIER_2_MANUAL:
  case QualificationTier.TIER_3_MANUAL: {
    return ProcessOptions.approved
  }
  case QualificationTier.DISQUALIFIED: {
    return ProcessOptions.rejected
  }
  default: {
    return ProcessOptions.unchanged
  }
  }
}

